export const initMeinAbax = () => {
  const profileReactionModal = document.querySelector(
    ".abax-confirmation-overlay"
  )
  if (profileReactionModal) {
    document.querySelectorAll(".abax-profile-reaction").forEach((button) => {
      button.addEventListener("click", (event) => {
        const reactionType = event.target.classList.contains("active")
          ? "open"
          : event.target.getAttribute("data-reaction-type")
        profileReactionModal.classList.add("open")
        profileReactionModal.setAttribute("data-reaction-type", reactionType)
        profileReactionModal.setAttribute(
          "data-profile-id",
          event.target.getAttribute("data-profile-id")
        )
        const reactionLabel = profileReactionModal.querySelector(
          "span.reaction-type-label"
        )
        if (reactionLabel) {
          console.log(event.target.innerText)
          reactionLabel.textContent = event.target.innerText
          if (reactionType === "open") {
            reactionLabel.innerText = "Zurücksetzen"
          }
        }
      })
    })

    const cancelReactionModal = document.querySelector(
      "form.confirmation-form button.modal-cancel"
    )
    if (cancelReactionModal) {
      cancelReactionModal.addEventListener("click", (event) => {
        event.preventDefault()
        profileReactionModal.classList.remove("open")
      })

      const actualModal = profileReactionModal.querySelector(
        ".abax-confirmation-modal"
      )

      document.addEventListener("click", (event) => {
        if (
          !event.target.classList.contains("abax-profile-reaction") &&
          !actualModal.contains(event.target) &&
          profileReactionModal.classList.contains("open")
        ) {
          profileReactionModal.classList.remove("open")
        }
      })
    }

    const reactionForm = document.querySelector("form.confirmation-form")
    if (reactionForm) {
      reactionForm.addEventListener("submit", async (event) => {
        event.preventDefault()
        const submitButton = reactionForm.querySelector('input[type=submit]')
        const comment = event.target.querySelector("textarea").value

        try {
          submitButton.disabled = true
          const response = await fetch("/wp-json/abax/v1/profile-response", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-WP-Nonce": document.querySelector("input.meinabax-nonce")
                .value,
            },
            body: JSON.stringify({
              profileId: profileReactionModal.getAttribute("data-profile-id"),
              userId: profileReactionModal.getAttribute("data-user-id"),
              status: profileReactionModal.getAttribute("data-reaction-type"),
              comment: comment,
            }),
          })
          response.json().then(() => {
            window.location.reload()
          })
        } catch (error) {
          submitButton.disabled = false
          console.log(error)
        }
      })
    }
  }

  const profileShareModal = document.querySelector(".abax-share-overlay")
  if (profileShareModal) {
    document.querySelectorAll(".abax-profile-meta .share").forEach((button) => {
      button.addEventListener("click", () => {
        profileShareModal.setAttribute(
          "data-share-id",
          button.getAttribute("data-share-id")
        )
        profileShareModal.setAttribute(
          "data-profile-id",
          button.getAttribute("data-profile-id")
        )
        profileShareModal.classList.add("open")
      })
    })

    profileShareModal
      .querySelector("button.cancel")
      .addEventListener("click", (event) => {
        profileShareModal.classList.remove("open")
      })

    const actualModal = profileShareModal.querySelector(".abax-share-modal")
    document.addEventListener("click", (event) => {
      if (
        !event.target.classList.contains("share") &&
        !actualModal.contains(event.target) &&
        profileShareModal.classList.contains("open")
      ) {
        profileShareModal.classList.remove("open")
      }
    })

    const confirmShare = profileShareModal.querySelector(
      "button.add-new-subshare"
    )
    if (confirmShare) {
      confirmShare.addEventListener("click", async () => {
        const profileId = profileShareModal.getAttribute("data-profile-id")
        const emailInput = profileShareModal.querySelector(
          'input[type="email"]'
        )
        if (emailInput && emailInput.value) {
          confirmShare.disabled = true
          try {
            const response = await fetch("/wp-json/abax/v1/share-profile", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": document.querySelector("input.meinabax-nonce")
                  .value,
              },
              body: JSON.stringify({
                profileId: profileId,
                emailAddresses: emailInput.value,
              }),
            })
            if (response.status == 200) {
              response.json().then((data) => {
                const responseHolder =
                  profileShareModal.querySelector(".share-response")
                if (responseHolder) {
                  responseHolder.innerText =
                    data.share_count > 0
                      ? `Bewerberprofil erfolgreich mit ${data.share_count} Personen geteilt`
                      : "Keine Freigabe durchgeführt - E-Mail-Adresse(n) ungültig oder Profile bereits freigegeben"
                      responseHolder.classList.add('visible')
                  setTimeout(() => {
                    responseHolder.classList.remove('visible')
                  }, 3000)
                }

                emailInput.value = ""
                confirmShare.disabled = false
              })
            }
          } catch (error) {
            confirmShare.disabled = false
            console.log(error)
          }
        }
      })
    }
  }

  // Filter für Mein ABAX
  if (document.querySelector(".abax-profile-filters")) {
    const filterButtons = document.querySelectorAll("li.abax-filter")
    filterButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        filterButtons.forEach((button) => {
          if (button !== event.target) {
            button.classList.remove("active")
          }
        })

        if (
          button.classList.contains("active") ||
          button.classList.contains("no-profiles")
        ) {
          return
        } else {
          button.classList.add("active")
        }

        const profileContainer = document.querySelector(".profiles-list")
        if (profileContainer) {
          profileContainer.classList.add("fading")
          setTimeout(() => {
            profileContainer.classList.remove("fading")
          }, 300)
        }

        const filterIds = button.getAttribute("data-type")

        filterButtons.forEach((button) => {
          if (button !== event.target) {
            button.classList.remove("active")
          }
        })

        document.querySelectorAll(".abax-profile").forEach((profile) => {
          if (
            (filterIds.indexOf(profile.getAttribute("data-type")) != -1 ||
              filterIds === "all") &&
            !profile.classList.contains("no-open-profiles")
          ) {
            setTimeout(() => {
              profile.style.display = "initial"
            }, 300)
          } else {
            setTimeout(() => {
              profile.style.display = "none"
              AOS.refresh()
            }, 300)
          }
        })
      })
    })
  }
}